export const bsbParser = (v?: string) => {
  if (!v) return undefined;
  const digits = v.replace(/[^\d]/g, '');
  if (digits.length <= 0) return undefined;
  return `${digits.slice(0, 6)}`;
};
